import type { CustomField } from '@libs/domain';

class SingleCustomField implements Pick<CustomField['schema'], 'customFieldKey' | 'customFieldValue'> {
  private constructor(
    readonly customFieldKey: number,
    readonly customFieldValue: string,
  ) {}

  static init(key: number) {
    return new SingleCustomField(key, '');
  }

  static fromRaw(raw: SingleCustomFieldRaw) {
    return new SingleCustomField(raw.customFieldKey, raw.customFieldValue);
  }
}

class SingleCustomFieldRaw implements Pick<CustomField['record'], 'customFieldKey' | 'customFieldValue'> {
  private constructor(
    readonly customFieldKey: number,
    readonly customFieldValue: string,
  ) {}

  static fromModel(m: SingleCustomField) {
    return new SingleCustomFieldRaw(m.customFieldKey, m.customFieldValue);
  }
}

export { SingleCustomField, SingleCustomFieldRaw };
